import {
  TableHead,
  cn,
  ArrowUp,
  ArrowDown,
  ArrowUpDown,
} from '@ufc/uikit'

interface SortableHeaderProps<T extends string> {
  label: string
  sortKey?: T
  currentSortField?: T
  currentSortOrder?: 'asc' | 'desc'
  onSort?: (field: T) => void
  align?: 'start' | 'center' | 'end'
}

export function SortableHeader<T extends string>({
  label,
  sortKey,
  currentSortField,
  currentSortOrder,
  onSort,
  align = 'start',
}: SortableHeaderProps<T>) {
  const isSortable = !!sortKey && !!onSort
  const isActive = sortKey === currentSortField

  const handleClick = () => {
    if (isSortable && sortKey) {
      onSort(sortKey)
    }
  }

  const SortIcon = isActive
    ? currentSortOrder === 'asc'
      ? ArrowUp
      : ArrowDown
    : ArrowUpDown

  return (
    <TableHead
      className={cn(
        'text-muted-foreground font-bold px-5 py-4 text-[11px] uppercase tracking-wider',
        isSortable && 'cursor-pointer hover:text-foreground hover:bg-muted/30 transition-colors select-none',
        isActive && 'text-foreground',
        align === 'end' && 'text-end',
      )}
      onClick={isSortable ? handleClick : undefined}
    >
      <div className={cn('flex items-center gap-1.5', align === 'end' && 'justify-end')}>
        <span>{label}</span>
        {isSortable && (
          <SortIcon
            className={cn(
              'w-3.5 h-3.5 shrink-0 transition-colors',
              isActive ? 'text-primary' : 'text-muted-foreground/50',
            )}
          />
        )}
      </div>
    </TableHead>
  )
}
